import FirebaseAdapter from "@wc/adapters/firebase";

/**
 * Switches the user's active organization
 * @param {string} userId The user's id
 * @param {string} organizationId The organization id to switch to
 * @returns {Promise<void>} Nothing
 * @throws {Error} If user is not a member of the organization
 */
export async function switchOrganization(userId, organizationId) {
  // Verify the user is a member of the organization
  const isMember = await FirebaseAdapter().membership.checkOrgAccess(
    userId,
    organizationId,
  );

  if (!isMember) {
    throw new Error("User is not a member of this organization");
  }

  // Update the user's active organization
  await FirebaseAdapter().users.updateUserActiveOrg(userId, organizationId);
}
